import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import { buildQueryParams } from '@/hooks/api/helpers';
import type {
  FanguardApiContractsPagedItemsModel1FanguardApiContractsPersonPersonSummaryModel,
  FanguardApiContractsPersonPersonDetailModel,
  SortDirection,
} from 'src/api/generated';

export const PERSONS_URI = 'persons';

export interface PersonsListParams {
  page?: number;
  pageSize?: number;
  watchlistId?: string;
  searchTerm?: string;
  sortOrder?: string;
  photosCountFrom?: number;
  photosCountTo?: number;
  excludeWatchlistId?: string;
  sortDirection?: SortDirection;
}

export const personsQueries = createQueryKeys(PERSONS_URI, {
  all: null,
  detail: (personId: string) => ({
    queryKey: [personId],
    queryFn: async () => {
      const response = await get<FanguardApiContractsPersonPersonDetailModel>({
        uri: `${PERSONS_URI}/${personId}`,
      });
      return response;
    },
  }),
  list: (params: PersonsListParams) => {
    const normalized = {
      page: params.page ?? 1,
      pageSize: params.pageSize ?? 25,
      watchlistId: params.watchlistId,
      searchTerm: params.searchTerm ?? '',
      sortOrder: params.sortOrder ?? 'firstName',
      photosCountFrom: params.photosCountFrom,
      photosCountTo: params.photosCountTo,
      excludeWatchlistId: params.excludeWatchlistId,
      sortDirection: params.sortDirection,
    };
    return {
      queryKey: [normalized],
      queryFn: async () => {
        const response = await get<FanguardApiContractsPagedItemsModel1FanguardApiContractsPersonPersonSummaryModel>({
          uri: `${PERSONS_URI}?${buildQueryParams(normalized)}`,
        });
        return response.data;
      },
    };
  },
});
